module.exports = __webpack_public_path__ + "img/img-8-mobile.f934a1e6.png";